import React from 'react';
import { Outlet } from 'react-router';
import ErrorMsg from '../ErrorMsg';

const BaseLayout: React.FC = () => {
  return (
    <>
      <Outlet />
      <ErrorMsg />
    </>
  );
};

export default BaseLayout;
